<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="h-full fixed inset-0 flex flex-col overflow-hidden">
    <router-link
      class="bg-blue-800 flex items-center justify-center text-white text-sm md:text-md font-medium hover:bg-blue-700 transition-all"
      style="height: 50px"
      to="/admin"
      v-if="
        userInfo.role !== 'media_purchaser' &&
          userInfo.role !== 'media_producer'
      "
      >Previewing Media Area <span class="px-2 block">&bull;</span> Click to
      Return to Admin
    </router-link>
    <div
      class="flex overflow-hidden bg-gray-100 z-20"
      :style="{
        height:
          userInfo.role !== 'media_purchaser' &&
          userInfo.role !== 'media_producer'
            ? 'calc(100vh - 50px)'
            : ''
      }"
    >
      <transition
        enter-active-class="transition-opacity ease-linear duration-300"
        leave-active-class="transition-opacity ease-linear duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div class="md:hidden" v-if="menuOpen">
          <div class="fixed inset-0 flex z-40">
            <div class="fixed inset-0 z-40">
              <div
                class="absolute inset-0 bg-gray-600 opacity-75 z-40"
                @click.self="toggleMenu"
              ></div>
            </div>
          </div>
        </div>
      </transition>

      <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
      <transition
        enter-active-class="transition ease-in-out duration-300 transform"
        leave-active-class="transition ease-in-out duration-300 transform"
        enter-class="-translate-x-full"
        enter-to-class="translate-x-0"
        leave-class="translate-x-0"
        leave-to-class="-translate-x-full"
      >
        <div class="md:hidden" v-if="menuOpen">
          <div class="fixed inset-0 flex z-40">
            <div
              class="relative flex-1 flex flex-col max-w-xs w-full bg-white"
              v-if="menuOpen"
            >
              <div class="absolute top-0 right-0 -mr-12 pt-2">
                <button
                  class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  v-on:click="toggleMenu"
                >
                  <span class="sr-only">Close sidebar</span>
                  <!-- Heroicon name: outline/x -->
                  <svg
                    class="h-6 w-6 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                <div class="flex-shrink-0 flex items-center px-4">
                  <h1 class="text-xl font-bold">Live Storms Media</h1>
                </div>
                <MediaNav />
              </div>
              <MediaNavBottom />
            </div>
            <div class="flex-shrink-0 w-14">
              <!-- Force sidebar to shrink to fit close icon -->
            </div>
          </div>
        </div>
      </transition>

      <!-- Static sidebar for desktop -->
      <div class="hidden md:flex md:flex-shrink-0">
        <div class="flex flex-col w-72">
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <div
            class="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white"
          >
            <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <div class="flex items-center flex-shrink-0 px-4">
                <h1 class="text-xl font-bold">Live Storms Media</h1>
              </div>
              <MediaNav />
            </div>
            <MediaNavBottom />
          </div>
        </div>
      </div>

      <div
        class="flex-1 overflow-auto focus:outline-none"
        v-on:scroll="handleScroll"
      >
        <div class="md:hidden flex items-center pl-1 pt-1 bg-gray-300">
          <button
            class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            v-on:click="toggleMenu"
          >
            <span class="sr-only">Open sidebar</span>
            <!-- Heroicon name: outline/menu -->
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <h1 class="text-lg font-medium">Live Storms Media</h1>
        </div>
        <router-view></router-view>
      </div>
    </div>
    <VideoPopPopover
      :isOpen="showVideoPopover"
      @closePopover="toggleVideoPopver"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MediaNav from "./partials/Nav";
import MediaNavBottom from "./partials/NavBottom";
import VideoPopPopover from "./partials/VideoPopOver";

export default {
  name: "MediaLayout",
  data() {
    return {
      menuOpen: false,
      showVideoPopover: false
    };
  },
  mounted() {
    this.$eventBus.$on("openSlideOver", () => {
      this.showVideoPopover = true;
    });
  },
  destroyed() {
    this.$eventBus.$off("openSlideOver", () => {
      this.showVideoPopover = false;
    });
  },
  components: { MediaNav, MediaNavBottom, VideoPopPopover },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    handleScroll() {
      this.$eventBus.$emit("scroll");
    },
    toggleVideoPopver() {
      this.showVideoPopover = !this.showVideoPopover;
    }
  }
};
</script>
